var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('Loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]}),_c('memo-table',{ref:"memoTable",attrs:{"query-memo":_vm.queryMemo,"save-memo":_vm.saveMemo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }